export default {
  SET_PRJ_DATE: (state, payload) => (state.prjDate = payload),
};
